import { Component, Input, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { profileContactModel } from 'src/app/Modules/management/models/organization/organization.model';
import { CustomAvatarService } from 'src/app/services/custom-avatar.service';
@Component({
    selector: 'app-add-user-for-instance-modal',
    templateUrl: './add-user-for-instance-modal.component.html',
    styleUrls: ['./add-user-for-instance-modal.component.scss'],
    standalone: false,
})
export class AddUserForInstanceModalComponent implements OnInit {
    @ViewChild('userCard') userCard: ElementRef;
    @Input() usersList: profileContactModel[];

    selectedUser: profileContactModel;
    searchInput: string;
    isUserSelected: boolean = false;
    selectedUserNumber: number;
    userListCopy: profileContactModel[];

    constructor(
        private ngbActiveModal: NgbActiveModal,
        private customAvatarService: CustomAvatarService
    ) {}

    ngOnInit(): void {
        this.userListCopy = this.usersList;
    }

    ngAfterViewInit(): void {}

    selectUser(user: any, selectedUser: number) {
        this.isUserSelected = true;
        this.selectedUser = user;
        let element = <HTMLElement>this.userCard.nativeElement;
        let children = [];
        for (let x = 0; x < element.children.length; x++) {
            element.children[x].classList.remove('user-active');
            //  children.push(<HTMLElement>element.children[x])
        }
        let x = document.getElementById(`user-${selectedUser} ${user.firstName}`);
        x.classList.add('user-active');
        this.selectedUserNumber = selectedUser;
    }

    persistTheUserSelection() {
        if (this.isUserSelected) {
            let x = document.getElementById(`user-${this.selectedUserNumber} ${this.selectedUser.firstName} `);
            if (x) {
                x.classList.add('user-active');
            }
        }
    }

    addClick() {
        this.ngbActiveModal.close(this.selectedUser);
    }

    closeClick() {
        this.ngbActiveModal.close();
    }

    searchResult(event) {
        this.usersList = this.userListCopy.filter((item) => {
            return (
                (
                    (item.firstName !== undefined ? item.firstName : '').trim().toLowerCase() +
                    (item.lastName !== undefined ? item?.lastName : '').trim().toLowerCase()
                )
                    .replace(/\s/g, '')
                    .includes(event.target.value.replace(/\s/g, '').trim().toLowerCase()) ||
                (
                    (item.firstName !== undefined ? item.firstName : '').replace(/\s/g, '').toLowerCase() +
                    ' ' +
                    (item.lastName !== undefined ? item?.lastName : '').replace(/\s/g, '').toLowerCase()
                ).includes(event.target.value.trim().replace(/\s/g, '').toLowerCase()) ||
                (
                    (item.firstName !== undefined ? item.firstName : '').toLowerCase() + (item.lastName !== undefined ? item?.lastName : '').toLowerCase()
                ).includes(event.target.value.trim().toLowerCase()) ||
                (
                    (item.firstName !== undefined ? item.firstName : '').trim().toLowerCase() +
                    (item.lastName !== undefined ? item?.lastName : '').trim().toLowerCase()
                ).includes(event.target.value.trim().replace(/\s/g, '').toLowerCase()) ||
                ((item.firstName !== undefined ? item.firstName : '').toLowerCase() + (item.lastName !== undefined ? item?.lastName : '').toLowerCase())
                    .replace(/\s/g, '')
                    .includes(event.target.value.replace(/\s/g, '').toLowerCase()) ||
                (item.email !== undefined ? item.email : '').toLowerCase().includes(event.target.value.trim().replace(/\s/g, '').toLowerCase())
            );
        });
        if (this.usersList != null || this.usersList != undefined) {
            this.persistTheUserSelection();
        }
    }

    getInitials(name: string): string {
        if (!name) return '';
        return this.customAvatarService.getShortInitials(name);
    }
}
